// Dawn – autoplay filmów w galerii bez klikania (miniatura / mały widok)
(function init(){
  // Ładuj tylko na produktach (gdyby ktoś go dodał globalnie)
  if (!document.body || !document.body.className.match(/(template-product|product)/)) {
    // jeśli nie masz klasy na <body>, to usuń ten warunek
  }

  // Obserwujemy WSZYSTKIE <deferred-media> w galerii
  const medias = Array.from(document.querySelectorAll(
    // typowe lokacje w Dawn 7–13
    '.product__media-list deferred-media, .product__media deferred-media, deferred-media[data-media-id]'
  ));
  if (!medias.length) return;

  // IO – gdy slajd z filmem jest w 50% w kadrze, ładuj i odtwarzaj
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const dm = e.target;
      if (e.isIntersecting) {
        ensureLoadedAndPlay(dm);
      } else {
        pause(dm);
      }
    });
  }, { threshold: 0.5 });

  medias.forEach(m => io.observe(m));

  // Reaguj na zmianę aktywnego slajdu w sliderze Dawn
  // (media-gallery/slider-component nie zawsze emituje publiczne eventy, więc czytamy aria)
  const sliderRoots = document.querySelectorAll('media-gallery, slider-component, .product__media-list');
  sliderRoots.forEach(root => {
    root.addEventListener('scroll', debounce(syncWithActive, 120), { passive: true });
    root.addEventListener('keyup', debounce(syncWithActive, 120));
    root.addEventListener('click', debounce(syncWithActive, 120));
  });
  // Pierwsza synchronizacja
  syncWithActive();

  function syncWithActive() {
    // aktywny slajd bywa oznaczony aria-current="true" albo .is-active
    const activeDM =
      document.querySelector('[aria-current="true"] deferred-media') ||
      document.querySelector('.is-active deferred-media');
    if (activeDM) {
      ensureLoadedAndPlay(activeDM);
      // zatrzymaj resztę
      medias.forEach(dm => { if (dm !== activeDM) pause(dm); });
    }
  }

  function ensureLoadedAndPlay(dm) {
    if (!dm) return;

    // 1) Jeśli <video>/<iframe> jeszcze nie istnieje, wstrzyknij zawartość <template> (bez kliknięcia)
    if (!dm.querySelector('video, iframe')) {
      const tpl = dm.querySelector('template');
      if (tpl && tpl.content) {
        const frag = tpl.content.cloneNode(true);

        // Ustaw wymagane atrybuty NA OBIEKCIE we fragmencie (ważne dla iOS)
        const vFrag = frag.querySelector('video');
        if (vFrag) {
          vFrag.muted = true;
          vFrag.setAttribute('muted','');
          vFrag.playsInline = true;
          vFrag.setAttribute('playsinline','');
          vFrag.autoplay = true;
          vFrag.setAttribute('autoplay','');
          vFrag.loop = true;
          vFrag.setAttribute('loop','');
          // w małym widoku zwykle bez kontrolek
          vFrag.removeAttribute('controls');
        }

        dm.appendChild(frag);
      } else {
        // awaryjnie spróbuj "kliknąć" plakat
        dm.querySelector('button.deferred-media__poster, .deferred-media__poster')?.click?.();
      }

      // usuń plakat/play overlay, żeby nic nie zasłaniało
      dm.querySelector('.deferred-media__poster, .deferred-media__poster-button')?.remove?.();
    }

    // 2) Odtwarzanie
    const video = dm.querySelector('video');
    if (video) {
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      // jeżeli przeglądarka opóźnia, powtórz po gotowości
      video.play().catch(() => {
        video.addEventListener('canplay', () => video.play().catch(()=>{}), { once: true });
      });
      return;
    }

    const iframe = dm.querySelector('iframe');
    if (iframe) {
      try {
        const u = new URL(iframe.src || '', location.href);
        // parametry przyjazne autoplay na mobile
        u.searchParams.set('autoplay', '1');
        u.searchParams.set('mute', '1');
        u.searchParams.set('playsinline', '1');
        // YouTube: włącz API by postMessage zadziałał
        u.searchParams.set('enablejsapi', '1');
        if (iframe.src !== u.toString()) {
          iframe.src = u.toString();
          iframe.addEventListener('load', () => postMessagePlay(iframe), { once: true });
        } else {
          postMessagePlay(iframe);
        }
      } catch(_){}
    }
  }

  function postMessagePlay(iframe) {
    if (!iframe.contentWindow) return;
    const src = iframe.src || '';
    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      const msg = JSON.stringify({ event: 'command', func: 'playVideo', args: [] });
      iframe.contentWindow.postMessage(msg, '*');
      return;
    }
    if (src.includes('vimeo.com')) {
      iframe.contentWindow.postMessage({ method: 'play' }, '*');
    }
  }

  function pause(dm) {
    const v = dm.querySelector('video');
    if (v && !v.paused) v.pause();

    const f = dm.querySelector('iframe');
    if (f && f.contentWindow) {
      const src = f.src || '';
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
      } else if (src.includes('vimeo.com')) {
        f.contentWindow.postMessage({ method: 'pause' }, '*');
      }
    }
  }

  function debounce(fn, wait){ let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), wait); }; }
})();
